import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import * as routes from "@/constants/routes";
import PageNotFound from "@/components/common/PageNotFound";

const DashboardRoutes = () => {
  const exportedRoutes = Object.values(routes)
    .filter((r) => r.route && r.component)
    .sort((a, b) => (b.priority || 0) - (a.priority || 0));

  return (
    <Switch>
      <Route
        exact
        path={routes.VIEW_MINE_PERMIT_AMENDMENT.route}
        component={routes.VIEW_MINE_PERMIT_AMENDMENT.component}
      />
      <Route
        exact
        path={routes.VIEW_MINE_PERMIT.route}
        component={routes.VIEW_MINE_PERMIT.component}
      />

      <Route
        exact
        path={routes.PERMIT_CONDITION_SEARCH.route}
        component={routes.PERMIT_CONDITION_SEARCH.component}
      />

      <Route
        exact
        path={routes.MINE_DASHBOARD.route}
        render={({ match }) => <Redirect to={routes.MINE_GENERAL.dynamicRoute(match.params.id)} />}
      />
      <Route path={routes.MINE_DASHBOARD.route} component={routes.MINE_DASHBOARD.component} />
      <Route
        exact
        path={routes.ADMIN_DASHBOARD.route}
        render={() => <Redirect to={routes.ADMIN_VERIFIED_MINES.dynamicRoute("verified")} />}
      />
      <Route path={routes.ADMIN_DASHBOARD.route} component={routes.ADMIN_DASHBOARD.component} />

      {exportedRoutes.map(({ route, component }) => (
        <Route exact path={route} component={component} key={route} />
      ))}
      <Route component={PageNotFound} />
    </Switch>
  );
};

export default DashboardRoutes;
